import React, { useState } from 'react';
import { Icon, StandAloneLink } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { TMappedShippingServices } from '@ecg-marktplaats/bff-buyers-domain/dist/node/shipping/types';

import Classes from './ModalLink.module.scss';
import { trackGAEvent } from '../../../../../../utils/gaTracking';
import { GA_TRACK_EVENTS_ACTIONS, GA_TRACK_EVENTS_LABELS } from '../../../../../../utils/constants';
import { TModalProps } from '../Modal/Modal';

type TShippingModalLinkProps = {
  formattedMinCost?: string;
  children?: React.ReactNode[] | React.ReactNode;
  shippingOptions: TMappedShippingServices;
};

let Modal: React.FC<TModalProps>;

const ShippingModalLink = ({ formattedMinCost, shippingOptions, children }: TShippingModalLinkProps) => {
  const { t } = useI18nContext();

  const [isOpen, setIsOpen] = useState(false);
  const [isModalLoaded, setIsModalLoaded] = useState(false);

  const loadModalComponent = async () => {
    Modal = (await import(/* webpackChunkName: "ShippingModal" */ '../Modal/Modal')).default;
    setIsModalLoaded(true);
  };

  const handleClick = () => {
    trackGAEvent(GA_TRACK_EVENTS_ACTIONS.Click, GA_TRACK_EVENTS_LABELS.Shipping, { category: 'VIP' });
    if (!isModalLoaded) {
      loadModalComponent();
    }
    setIsOpen(!isOpen);
  };

  return (
    <>
      <StandAloneLink
        iconRight="info"
        onClick={handleClick}
        className={Classes.shippingModalLink}
        data-testid="shippingModalLink"
      >
        {children ? (
          <>{children}</>
        ) : (
          <>
            <Icon name="truck" color="text-link-default" />
            <span className={Classes.label}>{t('shipping.costInfoFrom', { minimumCost: formattedMinCost })}</span>
          </>
        )}
      </StandAloneLink>
      {isModalLoaded && isOpen && <Modal toggle={handleClick} shippingOptions={shippingOptions} />}
    </>
  );
};

export default ShippingModalLink;
